<template>
  <div id="question-bank-list">
    <!-- 题库列表 -->
    <diy_table
      :loading="loading"
      :searchData="searchData"
      :buttonList="buttonList"
      :tableMenu="tableMenu"
      :tableData="tableData"
      :tableButton="tableButton"
      :pageData="pageData"
      @showActive="showActive"
      @handleClickTop="handleClickTop"
      @handleSortChange="handleSortChange"
      @initTable="initTable"
      @handleClick="handleClick"
    ></diy_table>

    <diy_dialog
      v-if="dialogData.flag"
      :title="dialogData.title"
      :width="dialogData.width"
      :dialogData="dialogData.dialogData"
      :buttonList="dialogData.buttonList"
      @colseDialog="colseDialog"
      @dialogOper="dialogOper"
    ></diy_dialog>
  </div>
</template>

<script>
import * as questionData from "../js/question.js";
import * as base from "../../js/base.js";
export default {
  data() {
    return {
      userData: {
        // 当前登录用户基本信息
        id: "",
      },
      // tipData: [
      //   { text: "全部", key: "all" },
      //   { text: "考试题库", key: "0" },
      //   { text: "练习题库", key: "1" },
      //   { text: "通用题库", key: "2" },
      // ],
      loading: false,
      // active: "all",
      searchData: questionData.getSearchData("question"),
      buttonList: questionData.getTopButArray("question"),
      tableMenu: questionData.getQuestionTableMenu(),
      tableData: [],
      tableButton: questionData.getTableBUttonList("question"),
      pageData: {
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页条数
        total: 20, // 总条目数
      },
      sortWay: "",

      tempQuestion: {},

      dialogData: {
        flag: false,
        title: "题库导入",
        width: "40%",
        tempData: {},
        dialogData: [
          {
            type: "select",
            title: "模板类型",
            options: [
              { label: "职业技能鉴定模板", value: "0" },
              { label: "上岗考核/专业题库模板", value: "1" },
              { label: "上岗考核/专业题库模板", value: "2" },
            ],
            placeholder: "选择上传模板类型",
            value: "",
          },
          {
            type: "select",
            title: "题库类型",
            options: [
              { label: "职业技能鉴定模板", value: "0" },
              { label: "上岗考核/专业题库模板", value: "1" },
              { label: "上岗考核/专业题库模板", value: "2" },
            ],
            placeholder: "选择上传模板类型",
            value: "",
          },
          {
            type: "select",
            title: "题库类型",
            options: [
              { label: "职业技能鉴定模板", value: "0" },
              { label: "上岗考核/专业题库模板", value: "1" },
              { label: "上岗考核/专业题库模板", value: "2" },
            ],
            placeholder: "选择上传模板类型",
            value: "",
          },
        ],
        buttonList: [
          { text: "确定", active: "makesure_choose_import_type" },
          { text: "取消", active: "cancel" },
        ],
      },
      importData: {
        successData: {
          // 导入成功数据
          num: 20,
          data: [
            {
              topicnType: "选择题", //  0 单选  1 多选 2 填空  3 判断  4 简答  5 实操
              questionStem: "题干题干",
              questionOptions: [],
              questionAnswer: [],
              gradeOfDifficulty: 3,
            },
          ],
        },
        errorData: {
          // 导入失败数据
          num: 20,
          data: [
            {
              name: "失败题干", //  0 单选  1 多选 2 填空  3 判断  4 简答  5 实操
              reason: "失败原因",
            },
          ],
        },
        similData: {
          // 导入的数据中相似度达到90%以上
          num: 20,
          data: [
            {
              topicnType: "选择题", //  0 单选  1 多选 2 填空  3 判断  4 简答  5 实操
              questionStem: "题干题干",
              questionOptions: [],
              questionAnswer: [],
              gradeOfDifficulty: 3,
              similQuestDataStem: "相似题干",
              similarity: "96%",
            },
          ],
        },
      },
      options: {
        subject: [],
        topicnType: [],
      },
    };
  },
  methods: {
    // 权限设置  获取部门设置界面所有子界面的权限  题库管理 24
    async getUsersAllAuthorityByModel() {
      try {
        let resultData = await this.$request({
          url: "/authority/getUsersAllAuthorityByModel",
          method: "post",
          data: { feature: "24" },
        });
        this.buttonList = base.returnAllButton(
          this.buttonList,
          resultData,
          "name"
        );
        this.tableButton = base.returnAllButton(
          this.tableButton,
          resultData,
          "text"
        );
      } catch (error) {}
    },
    /**
     * 获取所有科目
     */
    async getAllSubjectForSelect() {
      try {
        let resultData = await this.$request({
          url: "/subjects/getAllSubjectForSelect",
          method: "post",
          data: null,
        });
        this.options.subject = [];
        resultData.forEach((element) => {
          let dd = {
            label: element.name,
            value: element.id,
          };
          this.options.subject.push(dd);
        });
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 排序方式
     */
    async handleSortChange(data) {
      console.log(data);
      this.sortWay = data.order == null ? "" : data.order;
      await this.initTable({
        searchData: this.searchData,
        pageData: this.pageData,
      });
    },
    /**
     * 初始化表格数据
     */
    initTable(data) {
      this.loading = true;
      setTimeout(async () => {
        try {
          let requestData = {
            type: "2",
            currentPage: data.pageData.currentPage,
            pageSize: data.pageData.pageSize,
            searchData: {},
            sortWay: this.sortWay,
          };
          requestData.searchData = this.$baseData.array2json(
            data.searchData,
            requestData.searchData
          );
          console.log("获取所有题库", requestData);
          let resultData = await this.$request({
            url: "/questionBank/getAllQuestionBankList",
            method: "post",
            data: requestData,
          });
          this.pageData.total = resultData.total;
          this.tableData = resultData.tableData;
          this.loading = false;
        } catch (error) {
          console.log(error);
          this.$message.error(error.message);
          this.loading = false;
        }
      }, 500);
    },
    /**
     * 搜索框旁边的按钮操作
     */
    async handleClickTop(active) {
      switch (active) {
        case "import":
          // 导入
          try {
            let resultData = await this.$request({
              url: "/subjects/getAllSubjectForSelect",
              method: "post",
              data: null,
            });
            let subjectList = [];
            resultData.forEach((element) => {
              let dd = {
                label: element.name,
                value: element.id,
              };
              subjectList.push(dd);
            });
            this.dialogData.width = "40%";
            this.dialogData.title = "题库导入";
            this.dialogData.dialogData = [
              {
                type: "select",
                title: "模板类型",
                options: [
                  { label: "职业技能鉴定模板", value: "0" },
                  { label: "上岗考核/专业题库模板", value: "1" },
                  { label: "上岗考核/专业题库模板", value: "2" },
                ],
                placeholder: "选择上传模板类型",
                value: "0",
                key: "type",
              },
              // {
              //   type: "select",
              //   title: "题库类型",
              //   options: [
              //     { label: "考试题库", value: "0" },
              //     { label: "练习题库", value: "1" },
              //     { label: "通用题库", value: "2" },
              //   ],
              //   placeholder: "选择题库类型",
              //   value: "0",
              //   key: "questionType",
              // },
              {
                type: "select",
                title: "科目",
                options: subjectList,
                placeholder: "选择科目",
                value: "",
                key: "subject",
              },
            ];
            this.dialogData.buttonList = [
              { text: "确定", active: "makesure_choose_import_type" },
              { text: "取消", active: "cancel" },
            ];
            this.dialogData.flag = true;
          } catch (error) {
            this.$message.error(error.message);
          }
          break;
        case "create":
          // 新增
          this.$router.push({
            path: "/admin/question-bank-index/edit",
            query: {
              id: "",
            },
          });
          break;

        default:
          break;
      }
    },
    /**
     * 表格中的操作
     */
    handleClick(data) {
      this.tempQuestion = JSON.parse(JSON.stringify(data.item));
      switch (data.active) {
        case "edit_question":
          //   编辑题库
          console.log("编辑题库", data);
          this.$router.push({
            path: "/admin/question-bank-index/edit",
            query: {
              id: this.tempQuestion.id,
            },
          });
          break;
        case "delete_question":
          //   删除题库
          this.$confirm(
            "此操作将永久删除本题,且不会影响之前引用该题的试卷及考试, 是否继续?",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
            .then(async () => {
              let resultData = await this.$request({
                url: "/questionBank/deleteQuestionBankById",
                method: "post",
                data: { id: this.tempQuestion.id },
              });
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              await this.initTable({
                searchData: this.searchData,
                pageData: this.pageData,
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除",
              });
            });

          break;

        default:
          break;
      }
    },
    /**
     * active的监听事件
     */
    showActive(data) {
      this.active = data;
    },
    /**
     * 弹出框点击事件
     */
    async dialogOper(active) {
      try {
        let requestData = {};
        let resultData = {};
        let importData = [];
        switch (active) {
          case "makesure_choose_import_type":
            let fujiaData = {
              way: "0", // 导入方式
              fileUrl: "", // 已上传的模板路径
              fileName: "", // 已上传的模板名称
              wayOptions: [
                // 可选择的导入方式
                { label: "EXCEL 导入", value: "0" },
                { label: "WORD 导入", value: "1" },
              ],
            };
            fujiaData = this.$baseData.array2json(
              this.dialogData.dialogData,
              fujiaData
            );
            this.dialogData.dialogData = [
              {
                type: "import",
                value: fujiaData,
              },
            ];
            this.dialogData.buttonList = [
              { text: "确定", active: "makesure_import_question" },
              { text: "取消", active: "cancel" },
            ];
            break;
          case "makesure_import_question":
            console.log("上传模板", this.dialogData.dialogData);
            let tempData = JSON.parse(
              JSON.stringify(this.dialogData.dialogData[0].value)
            );
            requestData = {
              type: tempData.type,
              fileUrl: tempData.fileUrl,
              subject: tempData.subject,
            };
            let url =
              tempData.way == "0"
                ? "/questionBank/importQuestionBankByExcel"
                : "/questionBank/importQuestionBankByWord";
            let resultData = await this.$request({
              url: url,
              method: "post",
              data: requestData,
            });
            this.dialogData.width = "70%";
            this.dialogData.title = "题库导入";
            this.dialogData.dialogData = [
              {
                type: "import_result",
                value: resultData,
                // value: this.importData,
                tempData: tempData, // 科目  题库类型
              },
            ];
            this.dialogData.buttonList = [
              { text: "仅导入成功数据", active: "makesure_import_success" },
              {
                text: "导入成功或相似数据",
                active: "makesure_import_success_simile",
              },
              { text: "取消", active: "cancel" },
            ];
            break;
          case "makesure_import_success":
            // 仅导入成功数据
            this.dialogData.dialogData[0].value.successData.data.forEach(
              (element) => {
                this.$set(
                  element,
                  "subject",
                  this.dialogData.dialogData[0].tempData.subject
                );
                this.$set(
                  element,
                  "questionType",
                  // this.dialogData.dialogData[0].tempData.questionType
                  "2"
                );
                this.$set(element, "questionStemText", element.questionStem);
                this.conductImportData(element);
                importData.push(element);
              }
            );
            requestData = {
              importData: importData,
            };
            console.log("导入成功数据", requestData);
            let resultData1 = await this.$request({
              url: "/questionBank/addImportData",
              method: "post",
              data: requestData,
            });
            console.log("仅导入成功数据", resultData1);
            this.$message.success("导入成功");
            this.dialogData.flag = false;
            await this.initTable({
              searchData: this.searchData,
              pageData: this.pageData,
            });
            break;
          case "makesure_import_success_simile":
            // 导入成功或相似数据
            let dd = this.dialogData.dialogData[0].value;

            dd.successData.data.forEach((element) => {
              this.$set(
                element,
                "subject",
                this.dialogData.dialogData[0].tempData.subject
              );
              this.$set(
                element,
                "questionType",
                // this.dialogData.dialogData[0].tempData.questionType
                "2"
              );
              this.$set(element, "questionStemText", element.questionStem);
              this.conductImportData(element);
              importData.push(element);
            });
            dd.similData.data.forEach((element) => {
              let tt = {
                topicnType: element.topicnType,
                questionStem: element.questionStem,
                questionOptions: element.questionOptions,
                questionAnswer: element.questionAnswer,
                gradeOfDifficulty: element.gradeOfDifficulty,
                subject: this.dialogData.dialogData[0].tempData.subject,
                // questionType: this.dialogData.dialogData[0].tempData
                //   .questionType,
                questionType: "2",
              };
              this.$set(tt, "questionStemText", element.questionStem);
              this.conductImportData(tt);
              importData.push(tt);
            });
            requestData = {
              importData: importData,
            };
            console.log("导入成功数据", requestData);
            let resultData2 = await this.$request({
              url: "/questionBank/addImportData",
              method: "post",
              data: requestData,
            });
            this.$message.success("导入成功");
            this.colseDialog();
            await this.initTable({
              searchData: this.searchData,
              pageData: this.pageData,
            });
            break;
          case "cancel":
            this.colseDialog();
            break;

          default:
            break;
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 处理导入的数据中,判断题/填空题/简答题的答案数据格式
     */
    conductImportData(ele) {
      let questionAnswer = JSON.parse(JSON.stringify(ele.questionAnswer));
      let answer = [];
      if (ele.topicnType == "3") {
        // 判断题  将答案中的对/√改成0  错/×改成1
        questionAnswer.forEach((element) => {
          let e = element == "对" ? "0" : "1";
          let d = {
            htmlValue: e,
            value: e,
          };
          answer.push(d);
        });
      } else {
        // } else if (ele.topicnType == "2" || ele.topicnType == "4") {
        questionAnswer.forEach((element) => {
          let dd = {
            htmlValue: element,
            value: element,
          };
          answer.push(dd);
        });
      }
      // else {
      //   answer = questionAnswer;
      // }
      ele.questionAnswer = answer;
    },
    /**
     * 弹出框关闭事件
     */
    colseDialog() {
      this.dialogData.flag = false;
    },
  },
  async mounted() {
    await this.getUsersAllAuthorityByModel();
    await this.getAllSubjectForSelect();
    this.options.topicnType = this.$questionType;
    this.searchData.forEach((element) => {
      if (element.type == "select" || element.type == "selects") {
        element.options = this.options[element.key];
      }
    });
    await this.initTable({
      searchData: this.searchData,
      pageData: this.pageData,
    });
  },
};
</script>

<style lang="less" scoped>
#question-bank-list {
  width: 100%;
  height: 100%;
}
</style>